import React, { useCallback, useEffect } from 'react';

import { useHistory } from 'react-router-dom';

import * as NavigationUtils from '../../utils/navigation';

import Signature from './Signature';
import Header from '../../components/Header';
import Container from '../../components/Container';
import useSignature from '../../hooks/useSignature';

function SignatureContainer() {
	const history = useHistory();

	const {
		loading,
		canvasOptions,
		signatureOptions,
		getCanvasRef,
		textCanvasRef,
		save: baseSave,
		clear,
		undo,
		onChangeSignatureType,
		onChangeSignatureText,
		handleKeyDown,
		document,
		code
	} = useSignature();

	useEffect(() => {
		if (!document || !code) {
			return NavigationUtils.navigate(history, `?code=${code}`);
		}
	}, [history, code, document]);

	const save = useCallback(() => {
		baseSave();
		return NavigationUtils.navigate(history, `/document?code=${code}`);
	}, [baseSave, history, code]);

	const goBack = useCallback(() => {
		return NavigationUtils.navigate(history, `/document?code=${code}`);
	}, [history, code]);

    return (
		<Container>
			<Header/>

			<Signature
				canvasOptions={canvasOptions}
				save={save}
				clear={clear}
				undo={undo}
				goBack={goBack}
				loading={loading}
				getCanvasRef={getCanvasRef}
				textCanvasRef={textCanvasRef}
				signatureOptions={signatureOptions}
				onChangeSignatureType={onChangeSignatureType}
				onChangeSignatureText={onChangeSignatureText}
				handleKeyDown={handleKeyDown}
			/>
		</Container>
	);
}

export default SignatureContainer;
